import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

// components
import ErrorText from '../../../errors/ErrorText';
import AampeTooltip from '../../../shared/AampeTooltip/AampeTooltip';

interface DatasetDetails {
    datasetName: string;
    fieldName: string;
    fieldSample: string | string[];
}

interface DeeplinkViewProps {
    datasetDeeplink: DatasetDetails | null;
    staticDeeplink: string | null;
}

const DeeplinkView: React.FC<React.PropsWithChildren<DeeplinkViewProps>> = ({
    datasetDeeplink,
    staticDeeplink,
}) => {
    if (datasetDeeplink && staticDeeplink) {
        return (
            <Container>
                <ErrorText>
                    Error: Dataset deeplink and static deeplink may not be used
                    simultaneously.
                </ErrorText>
            </Container>
        );
    }

    if (datasetDeeplink) {
        return (
            <Container>
                <DatasetRow>
                    Dataset: <em>{datasetDeeplink.datasetName}</em>
                </DatasetRow>
                <DatasetRow>
                    Field: <em>{datasetDeeplink.fieldName}</em>
                </DatasetRow>
                <DeeplinkText>
                    Sample Value:{' '}
                    <em>
                        {Array.isArray(datasetDeeplink.fieldSample)
                            ? datasetDeeplink.fieldSample[0]
                            : datasetDeeplink.fieldSample}
                    </em>
                </DeeplinkText>
            </Container>
        );
    }
    return (
        <AampeTooltip title={staticDeeplink ?? ''} arrow placement="top">
            <DeeplinkText>{staticDeeplink || 'None'}</DeeplinkText>
        </AampeTooltip>
    );
};

export default DeeplinkView;

const Container = styled.div({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    width: '100%',
});

const DeeplinkText = styled.span({
    width: '80%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

const DatasetRow = styled.div({
    marginBottom: aampeTheme.spacing(1),
    overflowWrap: 'break-word',
    width: '300px',
});
